import { StoreAction, XmAction } from 'store/actions';
import { LineRetention } from './models/retention';

export function lineRetentionReducer(state: LineRetention, action: XmAction<LineRetention>): LineRetention {
    switch (action.type) {
        case StoreAction.GET_LINE_RETENTION:
            return action.payload;
        case StoreAction.CLEAR_LINE_RETENTION:
            return undefined;
        default:
            return state;
    }
}
